module.exports = __webpack_public_path__ + "img/cvlogo.a78c838f.png";